import {
  Control,
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";

import { IStationPriceAdditionDto } from "@ryde/shared";

export const emptyStationAddition: IStationPriceAdditionDto = {
  areaIds: [],
  price: "",
  startingFromStationIndex: "",
};

export interface IStationAdditionItemForm {
  fieldName: string;
  control?: Control;
  index?: number;
  onEdit?: () => void;
  onCancel?: () => void;
  value?: Partial<IStationPriceAdditionDto>;
  setValue: UseFormSetValue<FieldValues>;
  getValues: UseFormGetValues<FieldValues>;
  removeHandler?: (index: number) => void;
  isNew?: boolean;
}
